<template>
  <div class="publicannounce">
    <header-view :tabsign="5"></header-view>
    <div class="pic">公示公告</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>公示公告</span>
        </div>
      </div>

      <div class="centent">
        <div v-for="(item, index) in list" :key="index">
          <div @click="toDatail(index, item)">
            <div class="item">
              <div class="title overf-elli" :title="item.titile">{{ item.titile }}</div>
              <div class="right" style="font-size: 18px;">
                {{ item.sendTime }}
              </div>
            </div>
          </div>
          <!-- </router-link> -->
        </div>
      </div>
      
    </div>
    <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
  </div>
</template>

<script>
import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  name: "notice",
  components: {
    zhiniPagination,
  },
  data: function () {
    return {
      list: "",
      pageNo: 1,
      pageSize: 8,
      totalPage: 0,
      url: "",

      typesign: 0,
      searchv: "",
    };
  },
  created() {
    this.init();
	window.pageYOffset = 0;
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
  },
  watch: {
    $route() {
      this.typesign = this.$route.query.type;
    },
    typesign() {
      this.typesign = this.$route.query.type;
      this.init();
    },
  },
  methods: {
    //搜索
    changeinput() {
      this.init();
    },

    toDatail(indexsign, item) {
        this.$router.push({
			path: "/noticeDetails",
			query: { index: indexsign, id: item.id },
        });
    },

    init() {
      var that = this;
      var val = "sendTime";
      if (this.$route.query.type == 2) {
        val = "views";
      }
      this.httpGet("web/annountCement/webList", {
        sort: val,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        titile: this.searchv,
      }).then((res) => {
        that.list = res.result.records;
        that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      this.pageNo = e;
      this.init();
    },
  },
  mounted() {},
};
</script>
<style scoped="scoped" lang="scss">
.publicannounce {
  width: 100%;
  position: relative;
  margin-bottom: 10px;
  .pic {
    width: 100%;
    height: 400px;
    font-size: 75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin: 20px auto 10px;
    .centent {
      margin: 0 auto;
      .item {
        border-bottom: 1px dashed #e0e0e0;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 70px;
        cursor: pointer;
        padding-left: 20px;
        .title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          width: calc(100% - 170px);
        }
      }
      .item:hover {
        .title {
          color: rgba(230, 31, 38, 1);
        }
      }
    }
    .zhini-pagination {
      position: absolute;
      bottom: 55px;
      width: 100%;
      left: 0px;
    }

    .toptitle {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        .redcon {
          width: 5px;
          height:20px;
          background: #e70012;
          margin-right: 20px;
        }
        font-size: 25px;
        font-weight: 400;
        color: #e61f26;
      }
    }
  }
}
</style>